<div class="screen" [ngStyle]="{left:windowWidth}" *ngIf="this.showSplash">
    <div class="block">
        <img class="logo" src="assets/images/logo.png"><br>
        <img class="p-progress" src="assets/images/prog.gif">
    </div>
</div>
